/* eslint-disable camelcase */
import React from 'react'
import { TableRowProps } from './interfaces'
import { Trstyled } from './TableRowStyled'
import { Notifications } from 'library/constants'
import SFXS from '../../../assets/audios/audios'
import Currencies from 'functions/currency/getCurrencySymbol'

export default function TableRow({
  t,
  user_id,
  // toFix,
  handleAbove,
  handleNotification,
  strokeColor,
  requestBetReply,
  setRoundId,
  audio,
  betAmount,
  multiplier,
}: // payout,
// grid,
// maxWidth,
TableRowProps) {
  const { goForwardSFX } = SFXS
  goForwardSFX.volume = audio.volume

  // const profit = (t.winAmount - t.betAmount).toFixed(toFix)

  const profit = t.winAmount

  const getBetReply = (id: string) => {
    // console.log({ id }, Protocol.GET_ROUND)
    requestBetReply(id)
  }
  const clickHandler = (id: string, bet_user_id: string) => {
    // console.log({ id })
    if (bet_user_id === user_id) {
      audio.sound && goForwardSFX.play()
      handleAbove('Bet Reply')
      getBetReply(id)
      setRoundId(id)
    } else {
      handleNotification(Notifications.onlyYourBet)
    }
  }
  return (
    <Trstyled
      onClick={() => clickHandler(t.round_id, t.user_id)}
      cursorPointer={user_id === t.user_id}
      profit={+profit}
      strokeColor={strokeColor}
      multiplier={multiplier}
    >
      <td className='username'>{t.user_name}</td>
      <td className={`payout ${betAmount && 'bet-amount'}`}>
        {betAmount ? <p>{t.betAmount}</p> : <p>{t.winCoef.toFixed(2)}</p>}
        {betAmount ? <span>{Currencies[t.currency]}</span> : <span>x</span>}
      </td>
      {multiplier && (
        <td className='multiplier'>
          <p>{t.winCoef.toFixed(2)}x</p>
        </td>
      )}
      <td className='profit'>
        <p>{profit}</p>
        <span>
          {Currencies[t.currency]} {+profit > 0 ? '↑' : '↓'}
        </span>
      </td>
    </Trstyled>
  )
}
